import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';

import { retry, catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { BaseComponents } from '../base.component';

@Injectable()
export class SeoService extends BaseComponents{
  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient,
    public wpTokenService: WpTokenService,
    //private logger: NGXLogger
  ) { 
    super(injectorObj);
  }

  getTitle(path = "") {
    console.log(path);
    let self = this;
    //let url =  '/assets/data-blog/blog-contents.json';
    let url = environment.endpointBackend + '/api/title/get' + ( path ? '?web_url=' + path : "" );
    return new Promise(function (resolve, reject) {
      self.httpClient.get(url).pipe(
        catchError(self.handdleException),
        map(payload => {
          let result: any = payload
          return result
        }),
      ).subscribe(res=>{
        resolve(res)
      })
    });
  }

  handdleException(error: HttpErrorResponse): Observable<never> {
    //this.logger.info(error)
    return throwError(error)
  }
}
